import { Link } from "react-router-dom";
import { Reveal, Eyebrow } from "./Reveal";
import { IMAGES, TOWN_PAGES } from "../lib/site";

const ServiceArea = () => (
    <section className="max-w-7xl mx-auto px-5 sm:px-8 py-24" data-testid="service-area-section">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <Reveal>
                <Eyebrow className="mb-4">Service area</Eyebrow>
                <h2 className="font-display font-black uppercase text-brand-cream text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[0.95] mb-6">
                    30 miles around <span className="text-brand-amber">Poplar Bluff.</span>
                </h2>
                <p className="text-brand-sage text-base leading-relaxed mb-8 max-w-md">
                    Based right here in Poplar Bluff. If you're within about 30
                    miles of town, you're on our schedule — homes, rentals,
                    farms, and job sites.
                </p>
                <div className="flex flex-wrap gap-2" data-testid="service-area-towns">
                    {TOWN_PAGES.map((t) => (
                        <Link
                            key={t.slug}
                            to={`/stump-grinding/${t.slug}`}
                            data-testid={`service-area-town-${t.slug}`}
                            className={`font-mono text-[11px] uppercase tracking-wider rounded-full px-3.5 py-1.5 border transition-colors ${
                                t.slug === "poplar-bluff"
                                    ? "bg-brand-amber text-brand-ink border-brand-amber font-bold hover:bg-brand-amberHover"
                                    : "border-brand-line text-brand-sage hover:border-brand-amber hover:text-brand-amber"
                            }`}
                        >
                            {t.name}
                        </Link>
                    ))}
                    <span className="font-mono text-[11px] uppercase tracking-wider rounded-full px-3.5 py-1.5 border border-dashed border-brand-moss/50 text-brand-moss">
                        + everywhere in between
                    </span>
                </div>
            </Reveal>

            <Reveal delay={0.1}>
                <div className="relative overflow-hidden rounded-lg clip-notch border border-brand-line">
                    <img
                        src={IMAGES.stumpField}
                        alt="Tree stump in a grassy yard in the Ozarks"
                        className="w-full h-[420px] object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-brand-ink/80 via-transparent to-transparent" />
                    <div className="absolute bottom-0 inset-x-0 p-6 flex items-end justify-between">
                        <p className="font-mono text-xs uppercase tracking-[0.2em] text-brand-cream">
                            Poplar Bluff, MO — home base
                        </p>
                        <p className="font-mono text-xs uppercase tracking-[0.2em] text-brand-amber">
                            30 mi radius
                        </p>
                    </div>
                </div>
            </Reveal>
        </div>
    </section>
);

export default ServiceArea;
